const theme = {
    button: { background: '#eb5e28' },
}

export default theme